import { render, staticRenderFns } from "./ProductHistoryItem.vue?vue&type=template&id=60e66d83&scoped=true"
import script from "./ProductHistoryItem.vue?vue&type=script&lang=js"
export * from "./ProductHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryItem.vue?vue&type=style&index=0&id=60e66d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e66d83",
  null
  
)

export default component.exports